import { useInfiniteQuery } from "hooks/useInfiniteQuery";
import { getTrendingStrategies } from "../service";

export const useTrendingStrategies = ({
  page = 1,
  size = 10,
  enabled = true,
} = {}) => {
  const {
    data,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ["trending-strategies", page, size],
    queryFn: async ({ pageParam = 1 }) => {
      const params = {
        page: pageParam,
        size,
      };

      const response = await getTrendingStrategies(params);

      return {
        data: response.data,
        currentPage: response.page || pageParam,
        totalPages: response.total_pages,
        totalCount: response.total_count,
      };
    },
    enabled,
    getNextPageParam: (lastPage) => {
      const currentPage = Number(lastPage.currentPage);
      const totalPages = Number(lastPage.totalPages);
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
  });

  const allStrategies = data?.pages?.flatMap((page) => page.data) || [];
  const latestPage = data?.pages?.[data.pages.length - 1];
  const totalPages = latestPage?.totalPages || 0;
  const totalCount = latestPage?.totalCount || 0;
  const currentPage = latestPage?.currentPage || 1;

  return {
    strategies: allStrategies,
    totalPages,
    totalCount,
    currentPage,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    refetch,
    fetchNextPage,
  };
};
